module.exports = __webpack_public_path__ + "static/media/Icon awesome-twitter.f41a7cc7.svg";